import React, { FC, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useInView } from 'react-intersection-observer';
import { m, useAnimation } from 'framer-motion';

import Section from '../../../components/Section/Section';
import Title from '../../../components/Title/Title';
import Paragraph from '../../../components/Paragraph/Paragraph';
import { Content, Subtitle, Text } from './styled';
import { slideInLeft, slideInRight } from '../../../data/animations';

const Unique: FC<Queries.UniqueFragment> = ({ unique }) => {
  const { ref, inView } = useInView();
  const control = useAnimation();
  const [viewed, steViewed] = useState(false);

  useEffect(() => {
    if (inView) {
      control.start('visible');
      steViewed(true);
    } else {
      if (viewed) return;
      control.start('hidden');
    }
  }, [control, inView, viewed]);

  return (
    <Section ref={ref}>
      <Content>
        <Text variants={slideInLeft} initial="hidden" animate={control}>
          <Title style={{ textAlign: 'left' }}>{unique?.title}</Title>
          <Subtitle>{unique?.subtitle}</Subtitle>
          {unique?.description?.map(p => <Paragraph key={p}>{p}</Paragraph>)}
        </Text>
        {unique?.image?.childImageSharp?.gatsbyImageData && (
          <m.div variants={slideInRight} initial="hidden" animate={control}>
            <GatsbyImage
              image={unique?.image.childImageSharp?.gatsbyImageData}
              alt="Unique image"
              objectFit="contain"
            />
          </m.div>
        )}
      </Content>
    </Section>
  );
};

export const query = graphql`
  fragment Unique on Json {
    unique {
      title
      subtitle
      description
      image {
        childImageSharp {
          gatsbyImageData(width: 580, breakpoints: [768, 1024, 1440])
        }
      }
    }
  }
`;

export default Unique;
